/**
 * sort options by value converted to int
 **/
document.querySelectorAll('block-variant-picker[data-picker-type="button"]').forEach((picker) => {
  const options = [];
  picker.querySelectorAll('label').forEach((label) => {
    options.push({
      label,
      input: label.previousElementSibling
    });
  });

  options.sort((a, b) => {
    return parseFloat(a.input.value) - parseFloat(b.input.value);
  });


  options.forEach((option) => {
    const optionsWrapper = option.label.closest('fieldset');
    optionsWrapper.appendChild(option.input);
    optionsWrapper.appendChild(option.label);
  })
});

/**
 * htmlify accordion contents
 */
document.querySelectorAll('.collapsibles-wrapper .collapsible-content .metafield-multi_line_text_field').forEach((field) => {
  // ignore if a script tag is found
  if (!field.textContent.toLowerCase().includes('<script')) {
    field.innerHTML = field.textContent;
  }
});

/**
 * hide and mark accordions
 */
const filterAndMarkAccordions = (accordions) => {
    const tabsWithContent = [];
    accordions.forEach((item) => {
        const tab = item.closest('.product-block--tab');
        const isEmpty = item.textContent.replace(/\n/g, '').trim() === '';

        if (isEmpty) {
            tab.style.display = 'none';
        } else {
            tab.classList.add('product-block--has-content');
            tabsWithContent.push(tab); // store visible tabs
        }
    });

    // Remove previous markers if needed
    document.querySelectorAll('.product-block--tab.product-block--is-last-visible').forEach(el => {
        el.classList.remove('product-block--is-last-visible');
    });

    // Add marker to the last visible tab
    if (tabsWithContent.length > 0) {
        const lastTab = tabsWithContent[tabsWithContent.length - 1];
        lastTab.classList.add('product-block--is-last-visible');
    }
}

const accordions = document.querySelectorAll('.collapsibles-wrapper .collapsible-content');

if (accordions.length > 0) {
    filterAndMarkAccordions(accordions);
}

